import { render } from "./Info.vue?vue&type=template&id=abb9de30&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=abb9de30&lang=scss&scoped=true"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abb9de30"],['__file',"src/views/Info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "abb9de30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('abb9de30', __exports__)) {
    console.log('reload')
    api.reload('abb9de30', __exports__)
  }
  
  module.hot.accept("./Info.vue?vue&type=template&id=abb9de30&scoped=true", () => {
    console.log('re-render')
    api.rerender('abb9de30', render)
  })

}


export default __exports__